import { WorkloadReport } from './types';

/** Same scope/availability explanation on screen and in exported reports. */
export function sourceCoverageNotes(source: WorkloadReport['source'], text: (key: string, values?: Record<string, unknown>) => string): string[] {
  if (!source) return [text('observedCoverage')];
  if (source.sourceMode === 'retired') return [text('retainedCoverage')];
  if (source.sourceMode !== 'events') return [text('durableCoverage'),
    text(source.inventoryComplete ? 'inventoryReady' : 'inventoryPending'),
    text('sourceQueue', { count: source.queued, suffix: source.queueTruncated ? '+' : '' })];
  return [text('eventCoverage'),
    text(`inventory_${source.inventoryState ?? 'running'}`),
    text('inventoryCount', { count: source.enrolled }),
    text(source.processing?.available ? 'processingReady' : 'processingUnavailable'),
    source.queued === null || source.queued === undefined ? text('globalQueueUnknown') : text('globalQueue', { count: source.queued })];
}
